<script setup>
import ScrollToTop from '@core/components/ScrollToTop.vue'
import initCore from '@core/initCore'
import {
  initConfigStore,
  useConfigStore,
} from '@core/stores/config'
import { useModalStore } from '@/stores/ModalStore'
import { useUserStore } from "@/stores/UserStore"
import { useCalendarStore } from "@/views/apps/calendar/useCalendarStore"
import { useNotificationStore } from "@/stores/NotificationStore"
import { hexToRgb } from '@core/utils/colorConverter'
import { useTheme } from 'vuetify'
import CustomerCardDialog from "@/components/event/dialogs/CustomerCardDialog.vue"
import GeneralSearchBoxDialog from "@/components/dialogs/GeneralSearchBoxDialog.vue"
import CheckInternetStatus from "@/components/CheckInternetStatus.vue"
import TermsDialog from "@/components/dialogs/TermsDialog.vue"
import AgreementDialog from "@/components/dialogs/AgreementDialog.vue"
import { useCookie } from "@core/composable/useCookie"
import TopNotifications from "@/components/TopNotifications.vue"
import SnackbarNotifications from "@/components/SnackbarNotifications.vue"
import SmsDialog from "@/components/event/dialogs/SmsDialog.vue"
import GlobalConfirmationDialog from "@/components/dialogs/GlobalConfirmationDialog.vue"
import CalendarSalesDialog from "@/components/dialogs/CalendarSalesDialog.vue"
import PatternLock from "./components/PatternLock.vue"
import AddNewCustomerDialog from "./components/event/dialogs/AddNewCustomerDialog.vue"
import TagsManagerDialog from "@/components/dialogs/TagsManagerDialog.vue"
import TagEditDialog from "@/components/dialogs/TagEditDialog.vue"

const { global } = useTheme()

// B + Ł: for testing //7.9.5
useCookie('accessToken').value = null

// ℹ️ Sync current theme with initial loader theme
initCore()
initConfigStore()
const modalStore = useModalStore()
const calendarStore = useCalendarStore() //B: DON'T REMOVE THIS FROM HERE EVER!!! must stay because it prevents errors while using pinia store in router
const notificationStore = useNotificationStore()
const configStore = useConfigStore()
const userStore = useUserStore()

onMounted(async () => {
  if(isEmpty(userStore.currentUser?.employeeId)){
    const response = await userStore.getCurrentUserInfo()
    if(response?.success) {
      notificationStore.fetchNotifications().then(data => {})
    }
  }
  //await calendarStore.fetchCalendarSettings() //moved to 2.router.js
  useCookie('panelVersion', {
    domain: import.meta.env.VITE_COOKIE_DOMAIN,
    secure: true,
    sameSite: 'Lax',
  }).value = 2

  // START tracking user time -> userActivitySession.js
  const gp = getCurrentInstance()?.appContext?.config?.globalProperties || {}
  const start = gp.$startUserActivitySession || window.$startUserActivitySession
  if (start) start()

  // Apply stored color theme to sidebar and topbar of the app
  applyStoredColorTheme()

})

onBeforeUnmount(() => {
  // STOP tracking user time -> userActivitySession.js
  const stop = getCurrentInstance()?.appContext.config.globalProperties.$stopUserActivitySession
  if (stop) stop()
})
</script>

<template>
  <CheckInternetStatus />
  <TopNotifications />
  <SnackbarNotifications />
  <VLocaleProvider :rtl="configStore.isAppRTL">
    <!-- ℹ️ This is required to set the background color of active nav link based on currently active global theme's primary -->
    <VApp :style="`--v-global-theme-primary: ${hexToRgb(global.current.value.colors.primary)}`">
      <RouterView />

      <ScrollToTop />

      <!-- 👉 Confirmation dialog -->
      <GlobalConfirmationDialog />
      <!-- 👉 App Modal Search -->
      <GeneralSearchBoxDialog v-if="modalStore.modals.searchBoxDialog" />
      <!-- 👉 Terms modal -->
      <TermsDialog />
      <!-- 👉 Agreement modal -->
      <AgreementDialog />
      <!-- 👉 Sms modal -->
      <SmsDialog v-if="modalStore.modals.sendSmsToCustomer" />
      <!-- Pattern blockade -->
      <PatternLock />
      <!-- 👉 Add new customer modal-->
      <AddNewCustomerDialog v-if="modalStore.modals?.addNewCustomer" />
      <!-- 👉 Customer modal -->
      <CustomerCardDialog v-if="modalStore.modals?.customerCardDialog" />
      <!-- 👉 Sales modal -->
      <CalendarSalesDialog
        v-if="modalStore.modals?.calendarSales"
        :jump-to-date-fc="() => {}"
      />
      <!-- 👉 Tags management -->
      <TagsManagerDialog v-if="modalStore.modals?.tagsManager" />
      <TagEditDialog v-if="modalStore.modals?.editTag" />
    </VApp>
  </VLocaleProvider>
</template>
